'use strict';

import BaseService from './base.service';

class PendingSpendingsService extends BaseService {
    /* @ngInject */
    constructor(
        PendingSpending,
        SegaUser
    ) {
        super(PendingSpending, SegaUser);
        this.defaultOrder = 'createdAt DESC';
    }

    void(opts = {
        id: 0,
        reason: ''
    }) {
        return this.Model.void({
            id: opts.id,
            reason: opts.reason
        }).$promise;
    }

    addToVoucher(opts = {
        id: 0,
        voucherId: 0
    }) {
        return this.Model.addToVoucher({
            id: opts.id,
            voucherId: opts.voucherId
        }).$promise;
    }

    removeFromVoucher(opts = {
        id: 0,
        voucherId: 0
    }) {
        return this.Model.removeFromVoucher({
            id: opts.id,
            voucherId: opts.voucherId
        }).$promise;
    }
}

export default PendingSpendingsService;
